"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definition = void 0;
const lodash_functions_1 = require("../../../util/lodash-functions");
const default_session_1 = require("../../../session/default-session");
const news_provider_1 = require("../news-provider");
function Definition(params) {
    const parameters = (0, lodash_functions_1.isString)(params) ? { storyId: params } : params;
    return {
        getData(session = (0, default_session_1.getDefault)()) {
            const newsProvider = new news_provider_1.NewsProvider(session);
            return newsProvider.getStory(parameters);
        },
    };
}
exports.Definition = Definition;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmaW5pdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L25ld3Mvc3RvcnkvZGVmaW5pdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxxRUFBMEQ7QUFDMUQsc0VBQThEO0FBQzlELG9EQUFnRDtBQUloRCxTQUFnQixVQUFVLENBQUMsTUFBa0M7SUFDekQsTUFBTSxVQUFVLEdBQXNCLElBQUEsMkJBQVEsRUFBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQztJQUV0RixPQUFPO1FBQ0gsT0FBTyxDQUFDLFVBQW1CLElBQUEsNEJBQVUsR0FBRTtZQUNuQyxNQUFNLFlBQVksR0FBRyxJQUFJLDRCQUFZLENBQUMsT0FBTyxDQUFDLENBQUM7WUFFL0MsT0FBTyxZQUFZLENBQUMsUUFBUSxDQUFDLFVBQVUsQ0FBQyxDQUFDO1FBQzdDLENBQUM7S0FDSixDQUFDO0FBQ04sQ0FBQztBQVZELGdDQVVDIn0=